import React, { useContext, useState } from "react";
import { Modal, Select, Row, Col, Form, Upload, Input } from "antd";
import stateDistrictMapping from "../../assets/data/Indian_district_State.json";
import ApprovaContext from "../../context/approvalContext";
import TextArea from "antd/es/input/TextArea";
import uploadCloud from "../../assets/svg/uploadCloud.svg";
import { FileFilled } from "@ant-design/icons";
import { AiOutlineClose } from "react-icons/ai";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { ToastContainer, toast } from "react-toastify";

const { Option } = Select;

const AddApprovalRatingShape = ({ isOpen,setShowARShape }) => {
  const [form] = Form.useForm();
  const axiosInstance = useAxiosInstance();
  const approvaContext = useContext(ApprovaContext);

  const [fileList, setFileList] = useState([]);
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = 1951; year <= currentYear; year++) {
    years.push(year);
  }

  const [inputValues, setInputValues] = useState({
    state: null,
    district: null,
    // name: null,
    year: null,
    description: "",
    boundaries: []
  });

  const closeModal = () => {
    approvaContext.updateOpenModal(false);
    form.resetFields();
    setShowARShape(false)
    handleResetFile();
  };

  const handleResetFile = () => {
    setInputValues((prev) => ({ ...prev, boundaries: [] }));
    setFileList([]);
  };

  const stateOptions = Object.keys(stateDistrictMapping).map((state) => ({
    value: state,
    label: state
  }));

  const districtOptions = inputValues.state
    ? stateDistrictMapping[inputValues.state].map((district) => ({
        value: district,
        label: district
      }))
    : [];

  const handleChange = (value, name) => {
    setInputValues({ ...inputValues, [name]: value });
  };

  const handleGeoFileUpload = async (data) => {
    try {
      const response = await axiosInstance.post(
        "/api/approvalRating/createShapeFile",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      toast.success("Approval Rating Shape Uploaded Successfully");
      closeModal();
      return response?.data?.data;
    } catch (error) {
      console.error("GeoJSON upload failed:", error.message);
      toast.error("File upload failed");
      return null;
    }
  };

  const handleSubmitForm = () => {
    const data = {
      state: inputValues?.state,
      district: inputValues?.district,
    //   name: inputValues?.name,
      year: inputValues?.year,
      description: inputValues?.description,
      boundaries: inputValues?.boundaries[0]?.originFileObj
    };
    handleGeoFileUpload(data);
  };

  return (
    <>
      {isOpen && (
        <Modal
          className="add-user-modal"
          open={isOpen}
          onCancel={closeModal}
          width={1040}
          maskClosable={false}
          footer={[
            <button
              key="add-approval-shape"
              form="approval-shape-form"
              type="submit"
              className="add-user-btn"
              style={{ width: "auto" }}
            >
              Add Approval Rating Shape
            </button>
          ]}
        >
          <ToastContainer />
          <Form
            form={form}
            id="approval-shape-form"
            onFinish={handleSubmitForm}
            className="modal-body-container"
          >
            <div className="user-info-modal">
              <div className="modal-title">
                <h3>Add Approval Rating Shape</h3>
              </div>
            </div>
            <div className="modal-wrapper-body constituency-form">
              <div className="model-wrapper">
                <div className="modal-wrapper-content">
                  <h4>Approval Rating Shape Information</h4>

                  <Row className="add-modal-row mt-5 mb-2">
                    <Col span={8}>
                      <label>
                        Select State<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="state"
                        rules={[{ required: true, message: "Please Select State" }]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "state")}
                          options={stateOptions}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8} offset={2}>
                      <label>
                        Select District<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="district"
                        rules={[{ required: true, message: "Please Select District" }]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "district")}
                          options={districtOptions}
                          disabled={!inputValues.state}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            option.label.toLowerCase().includes(input.toLowerCase())
                          }
                          placeholder={
                            inputValues.state ? "Select District" : "Please select state first"
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="add-modal-row mb-2">
                    {/* <Col span={8}>
                      <label>Name<span className="required-field">*</span></label>
                      <Form.Item
                        name="name"
                        rules={[{ required: true, message: "Please enter Name" }]}
                      >
                        <Input
                          name="name"
                          onChange={(e) => handleChange(e.target.value, "name")}
                        />
                      </Form.Item>
                    </Col> */}

                    <Col span={8} offset={2}>
                      <label>Year<span className="required-field">*</span></label>
                      <Form.Item
                        name="year"
                        rules={[{ required: true, message: "Please Select Year" }]}
                      >
                        <Select
                          showSearch
                          onChange={(value) => handleChange(value, "year")}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.toString().toLowerCase().includes(input.toLowerCase())
                          }
                        >
                          {years.map((year) => (
                            <Option key={year} value={year}>
                              {year}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="add-modal-row mb-2">
                    <Col span={18}>
                      <label>
                        Description<span className="required-field">*</span>
                      </label>
                      <Form.Item
                        name="description"
                        rules={[{ required: true, message: "Please enter the Description" }]}
                      >
                        <TextArea
                          rows={2}
                          name="description"
                          onChange={(e) => handleChange(e.target.value, "description")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row className="add-modal-row mb-2">
                    <Col span={22}>
                      <h3>
                        Approval Rating Shape File (GeoJSON)
                        <span className="required-field">*</span>
                      </h3>
                      <Form.Item
                        name="boundaries"
                        rules={[{ required: true, message: "Please upload the shape file" }]}
                      >
                        <div className="constituency-upload-file">
                          <Upload.Dragger
                            key="select-file"
                            name="boundaries"
                            beforeUpload={() => false}
                            fileList={fileList}
                            onChange={(info) => {
                              const { file, fileList } = info;
                              if (file.status === "done") {
                                setFileList([file]);
                              } else {
                                setFileList(fileList);
                              }
                              handleChange(fileList, "boundaries");
                            }}
                            className="custom-file-upload"
                            accept=".json"
                          >
                            {inputValues?.boundaries.length > 0 ? (
                              <div className="fileUpload">
                                <div className="text-right">
                                  <button
                                    onClick={handleResetFile}
                                    className="reset-button font-bold"
                                  >
                                    <AiOutlineClose />
                                  </button>
                                </div>
                                <div className="flex file-icon">
                                  <FileFilled />
                                  <p>{inputValues?.boundaries[0]?.name}</p>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <img src={uploadCloud} alt="" className="m-auto" />
                                <p className="ant-upload-text">
                                  Select a file or drag and drop
                                </p>
                                <p className="ant-upload-text">
                                  GeoJSON file size no more than 10MB
                                </p>
                                <span className="select-file">Select File</span>
                              </div>
                            )}
                          </Upload.Dragger>
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default AddApprovalRatingShape;
